import React from 'react';
import { Route, Routes } from 'react-router';
import Login from './components/Login/Login';
import NotFound from './components/NotFound/NotFound';

export default function PublicApp() {

  return (
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signed-out' element={<Login />} />
        <Route path='/not-found' element={<NotFound />} />
        <Route path='*' element={<Login />} />
      </Routes>
  );
}
